/* Exact field names and order from 83 public product forms, checked 2026-10-02, plus the previously verified profiles. */
window.KMSaleProfiles = Object.freeze({
  "personalisiertes-fruhstucksbrettchen-niedliche-waldtiere": [
    {
      "key": "Wunschname hier eingeben",
      "required": true
    }
  ],
  "nachtlicht-kinder-niedliche-waldtiere": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum: (optional)",
      "type": "text",
      "required": false
    }
  ],
  "personalisierte-erinnerungskiste-waldtiere": [
    {
      "key": "Wunschname hier eingeben",
      "required": true
    },
    {
      "key": "Geburtsdatum",
      "required": false
    },
    {
      "key": "Geburtsgewicht (in Gramm)",
      "required": false
    },
    {
      "key": "Geburtsgröße (in cm)",
      "required": false
    },
    {
      "key": "Geburtszeit",
      "required": false
    }
  ],
  "nachtlicht-kinder-baby-reh": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum: (optional)",
      "type": "text",
      "required": false
    }
  ],
  "adventskalender-zum-befullen-weihnachten-im-winterwald-personalisiert": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "fruhstucksbrettchen-personalisiert-tier-familie": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "zahndose-milchzahndose-junge-madchen-personalisiert-aus-holz-kopie": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "zahndose-milchzahndose": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "nachtlicht-kinder-regenbogen": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum: (optional)",
      "type": "text",
      "required": false
    }
  ],
  "adventskalender-zum-befullen-bar-und-weihnachtsbaum-personalisiert": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "personalisierte-messlatte-lowe": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum",
      "type": "text",
      "required": false
    }
  ],
  "nachtlicht-kinder-reh": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum: (optional)",
      "type": "text",
      "required": false
    }
  ],
  "adventskalender-zum-befullen-waldtiere-um-den-weihnachtsbaum-personalisiert": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "nachtlicht-kinder-girl": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Datum (optional)",
      "type": "text",
      "required": false
    }
  ],
  "fruhstucksbrettchen-personalisiert-tigergesicht": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "tonieregal-aus-holz-personalisiert-frohliche-waldtiere": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "fruhstucksbrettchen-personalisiert-lowengesicht": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "adventskalender-zum-befullen-winterdorf-mit-tieren-personalisiert": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "nachtlicht-kinder-regenbogen-2": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum: (optional)",
      "type": "text",
      "required": false
    }
  ],
  "nachtlicht-kinder-baby-reh-im-wald": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum: (optional)",
      "type": "text",
      "required": false
    }
  ],
  "fruhstucksbrettchen-personalisiert-barengesicht-1": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "fruhstucksbrettchen-holz-personalisiert-niedliche-tiermotive": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "tonieregal-aus-holz-personalisiert-regenbogen-3": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "personalisierte-messlatte-tierfreunde-ballon": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum",
      "type": "text",
      "required": false
    }
  ],
  "schneidebrett-holz-flora": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "adventskalender-zum-befullen-weihnachten-mit-sussem-fuchs-personalisiert": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "kopie-von-tonieregal-aus-holz-personalisiert-woodland": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "fruhstucksbrettchen-personalisiert-hasengesicht": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "nachtlicht-kinder-loewe-boho": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum: (optional)",
      "type": "text",
      "required": false
    }
  ],
  "nachtlicht-kinder-fuchs": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum: (optional)",
      "type": "text",
      "required": false
    }
  ],
  "personalisierte-messlatte-regenbogen-wolken": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum",
      "type": "text",
      "required": false
    }
  ],
  "nachtlicht-kinder-bauernhof-tiere": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum: (optional)",
      "type": "text",
      "required": false
    }
  ],
  "tonieregal-aus-holz-personalisiert-regenbogen-herz-1": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "tonieregal-aus-holz-personalisiert-reh": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "nachtlicht-kinder-baby-tiere": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum: (optional)",
      "type": "text",
      "required": false
    }
  ],
  "personalisiertes-fruhstucksbrettchen-bar-boho": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "adventskalender-zum-befullen-tiere-und-weihnachtsbaum-personalisiert": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "spardose-kinder-sparschwein-personalisiert-bunt-bay-reh": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "personalisierte-messlatte-regenbogen-wolken-orange": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum",
      "type": "text",
      "required": false
    }
  ],
  "tonieregal-aus-holz-personalisiert-regenbogen": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "personalisierter-bambusteller-saugnapf-name-kinder": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "adventskalender-zum-befullen-weihnachten-mit-tieren-und-lichterkette-personalisiert": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "kindergarderobe-holz-personalisiert-mit-namen-blumen": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum (optional)",
      "type": "text",
      "required": false
    }
  ],
  "kindergarderobe-holz-personalisiert-mit-namen-loewe": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum (optional)",
      "type": "text",
      "required": false
    }
  ],
  "spardose-kinder-sparschwein-personalisiert-bunt-eichhornchen-waldtiere": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "spardose-kinder-sparschwein-personalisiert-bunt-bar-waldtiere": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "kindergarderobe-holz-personalisiert-mit-namen-baer": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum (optional)",
      "type": "text",
      "required": false
    }
  ],
  "personalisierte-adventskalender-lowe-gravur": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "spardose-kinder-aus-keramik-baby-reh": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "nachtlicht-kinder-regenbogen-dot": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Datum (optional)",
      "type": "text",
      "required": false
    }
  ],
  "kindergarderobe-holz-personalisiert-mit-namen-boho-regenbogen-tiere": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum (optional)",
      "type": "text",
      "required": false
    }
  ],
  "kopie-von-personalisierte-adventskalender-regenbogen": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "personalisierte-adventskalender-bar": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "messlatte-kinder-holz-aluverbund-waldtiere": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum",
      "type": "text",
      "required": false
    }
  ],
  "zahndose-baby-reh-personalisiert-holz-milchzahndose-namen": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "kinderteller-mit-saugnapf-personalisiert-mit-namen-waldtiere": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "garderobe-personalisiert-boho-tierfamilie-regenbogen": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum (optional)",
      "type": "text",
      "required": false
    }
  ],
  "personalisierte-adventskalender-lowe-1": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "kinderteller-mit-saugnapf-personalisiert-mit-namen-jungle-tiere-motiv": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "zahndose-milchzahne-personalisiert-holz-zahnbox-mit-wunschnamen-baby-tiger": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "personalisierter-adventskalender-zum-befullen-bear": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "personalisierte-adventskalender-elefant": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "messlatte-kinder-holz-aluverbund-niedliche-dinosaurier": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum",
      "type": "text",
      "required": false
    }
  ],
  "personalisierbarer-adventskalender-farbig-gluckliche-waldtiere": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "messlatte-kinder-holz-aluverbund-reh-im-wald": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum",
      "type": "text",
      "required": false
    }
  ],
  "nachtlicht-kinder-personalisiert-susse-dinosaurier": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum: (optional)",
      "type": "text",
      "required": false
    }
  ],
  "zahndose-baer-personalisiert-holz-milchzahndose-namen": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "milchzahndose-personalisiert-madchen-elefant-motiv": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "messlatte-kinder-holz-aluverbund-pferd": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    },
    {
      "key": "Geburtsdatum",
      "type": "text",
      "required": false
    }
  ],
  "kinderteller-mit-saugnapf-personalisiert-mit-namen-reh": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "spardose-kinder-aus-keramik-baer-waldtiere": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "personalisierbarer-adventskalender-farbig-niedliche-waldtiere-weihnachtsmutze": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "spardose-kinder-sparschwein-personalisiert-bunt-boho-bar": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "kinderteller-mit-saugnapf-personalisiert-mit-namen-biene-motiv": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "zahndose-milchzahne-personalisiert-holz-zahnbox-bar-mit-ballon": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "spardose-kinder-aus-keramik-boho-bar": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "kinderteller-mit-saugnapf-personalisiert-mit-namen-katze-motiv": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "personalisierbarer-adventskalender-farbig-niedliche-waldtiere": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "personalisierbarer-adventskalender-farbig-frohliche-tierfamilie": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "kinderteller-mit-saugnapf-personalisiert-mit-namen-fuchs-motiv": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "bambusteller-kinder-personalisiert-saugnapf-hase": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ],
  "personalisierbarer-adventskalender-farbig-niedliche-tiere": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "personalisierbarer-adventskalender-farbig-gluckliche-tierfamilie": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "kinderteller-mit-saugnapf-personalisiert-mit-namen-hase-mit-punkten-motiv": [
    {
      "key": "Wunschname hier eingeben:",
      "type": "text",
      "required": true
    }
  ],
  "kinderteller-mit-saugnapf-mit-namen-und-niedlichen-tiermotiven-kopie": [
    {
      "key": "Wunschname hier eingeben",
      "type": "text",
      "required": true
    }
  ]
});
/* Read other products' native Impact form fields without executing page scripts. */
window.KMSaleReadFields = function(html, product) {
  const doc=new DOMParser().parseFromString(html,'text/html');
  const form=Array.from(doc.querySelectorAll('form')).find(f=>f.id.startsWith('product-form-'+product.id+'-'));
  if(!form)throw Error('Die Produktoptionen konnten nicht geladen werden. Bitte versuche es erneut.');
  const nodes=Array.from(doc.querySelectorAll('input[name^="properties["],textarea[name^="properties["],select[name^="properties["]')).filter(n=>n.getAttribute('form')===form.id||(!n.getAttribute('form')&&form.contains(n)));
  const fields=[],keys=new Set();
  for(const node of nodes){
    const key=node.name.slice(11,-1),type=node.tagName==='SELECT'?'select':node.tagName==='TEXTAREA'?'textarea':node.type;
    if(!['text','textarea','select','number','date','email','tel','url','hidden'].includes(type)||keys.has(key)||node.multiple)throw Error('Dieses Produkt hat besondere Optionen. Bitte nutze dafür die vollständigen Produktdetails.');
    keys.add(key);const field={key,type,required:node.required};
    for(const attr of ['minlength','maxlength','pattern','min','max','step','placeholder'])if(node.hasAttribute(attr))field[attr]=node.getAttribute(attr);
    if(type==='hidden')field.value=node.value;
    if(type==='select')field.options=Array.from(node.options).map(o=>({value:o.value,label:o.textContent.trim(),disabled:o.disabled,selected:o.selected}));
    fields.push(field);
  }
  if(!fields.length&&/personalisier/i.test(product.title))throw Error('Die Personalisierungsfelder konnten nicht bestätigt werden. Bitte nutze die vollständigen Produktdetails.');
  return fields;
};
